/**
 * Genera un token de autenticación en base64.
 *
 * @returns {string} Token en base64.
 */
export const getAuthToken = (): string => {
  try {
    console.log(btoa(`${process.env.REACT_APP_CLIENT_ID}:${process.env.REACT_APP_CLIENT_SECRET}`));
    return btoa(
      `${process.env.REACT_APP_CLIENT_ID}:${process.env.REACT_APP_CLIENT_SECRET}`
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};
